import { render, staticRenderFns } from "./AvatarProfileWithBtns.vue?vue&type=template&id=9662854c&scoped=true&"
import script from "./AvatarProfileWithBtns.vue?vue&type=script&lang=js&"
export * from "./AvatarProfileWithBtns.vue?vue&type=script&lang=js&"
import style0 from "./AvatarProfileWithBtns.vue?vue&type=style&index=0&id=9662854c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9662854c",
  null
  
)

export default component.exports